import { FnBlock_UI } from "components/BlockUI";
import { useContext, useEffect, useState } from "react";
import { RecruitmentContext } from "./Recruitment_From";
import { Divider, Grid } from "@mui/material";
import Accordion from "components/Accordion";
import { FormProvider, useForm } from "react-hook-form";
import { SelectFormItem, TextBoxForm } from "components/Input";
import { DatePickerFromItem } from "components/Input/DatePicker";
import { BtnSaveIcon } from "components/Button";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { undefinedOrNull } from "utilities/Function";
import { SwAlert } from "components/Alert";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import { AxiosPost } from "utilities/Axios";
import moment from "moment";
const Consider_From = () => {
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [nStatusID, setnStatusID] = useState(null);
    const { objMasterData } = useContext(RecruitmentContext);
    const [dDateStart, setdDateStart] = useState(null);
    const [dDateEnd, setdDateEnd] = useState(null);
    const objSchema = yup.object().shape({
        nCompanyID: yupFormSchemas.string("บริษัท", { required: true }),
        nStatusID: yupFormSchemas.string("สถานะใบสมัคร", { required: true }),
        dContractStart: yupFormSchemas.string("วันที่เริ่มงาน", { required: nStatusID == 109 }),
        dContractEnd: yupFormSchemas.string("วันที่สิ้นสุดสัญญา", { required: nStatusID == 109 }),
        sPlaceOfWork: yupFormSchemas.string("สถานที่ทำงาน", { required: nStatusID == 109 }),
        sDepartment: yupFormSchemas.string("แผนก", { required: nStatusID == 109 }),
        sPosition: yupFormSchemas.string("ตำแหน่ง", { required: nStatusID == 109 }),
        sDescription: yupFormSchemas.string("รายละเอียดเพิ่มเติม", { required: nStatusID == 110 || nStatusID == 111 || nStatusID == 112 }),
    });

    const form = useForm({
        resolver: yupResolver(objSchema),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    useEffect(() => {
        if (objMasterData?.objConsideration) {
            form.reset(objMasterData?.objConsideration);
            form.setValue("nCompanyID", undefinedOrNull(objMasterData?.objConsideration?.nCompanyID, "string"))
            form.setValue("nStatusID", undefinedOrNull(objMasterData?.objConsideration?.nStatusID, "string"))
            form.setValue("dContractStart", moment(objMasterData?.objConsideration?.dContractStartDate));
            form.setValue("dContractEnd", moment(objMasterData?.objConsideration?.dContractEndDate));
            setnStatusID(objMasterData?.objConsideration?.nStatusID);
        }
    }, [objMasterData?.objConsideration])

    const onSave = () => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            BlockUI();
            let obj = {
                nRegisterID: objMasterData?.objData?.objFormData?.nRegisterID,
                nCompanyID: undefinedOrNull(form.getValues("nCompanyID"), "number"),
                nStatusID: undefinedOrNull(form.getValues("nStatusID"), "number"),
                sPlaceOfWork: undefinedOrNull(form.getValues("sPlaceOfWork"), "string"),
                sDepartment: undefinedOrNull(form.getValues("sDepartment"), "string"),
                sPosition: undefinedOrNull(form.getValues("sPosition"), "string"),
                sDescription: undefinedOrNull(form.getValues("sDescription"), "string"),
                dContractStart: undefinedOrNull(form.getValues("dContractStart"), "dateToString"),
                dContractEnd: undefinedOrNull(form.getValues("dContractEnd"), "dateToString"),
            }
            AxiosPost("UserRecruitment/onSaveConsideration", obj, (res) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {
                });
            }, null, null, null, () => {
                UnBlockUI();
            })
        });
    };

    return (
        <Grid item md={12}>
            <Accordion header="พิจารณาพนักงาน" isExpanded>
                <FormProvider {...form}>
                    <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
                        <Grid item md={12} xs={12}>
                            <Grid item md={4} xs={12}>
                                <SelectFormItem name={"nCompanyID"} label={"บริษัท"} required options={objMasterData?.lstCompany || []} disabled={!objMasterData.isEditData}/>
                            </Grid>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <SelectFormItem name={"nStatusID"} label={"สถานะใบสมัคร"} required options={objMasterData?.lstStatus || []} disabled={!objMasterData.isEditData} onChange={(e) => {
                                if (e) {
                                    setnStatusID(undefinedOrNull(e.value, "number"));
                                } else {
                                    setnStatusID(null);
                                }
                            }} />
                        </Grid>
                        {nStatusID == 109 && <Grid item md={3} xs={12}>
                            <DatePickerFromItem name={"dContractStart"} label={"วันที่เริ่มงาน"} openTo="day" fullWidth disabled={!objMasterData.isEditData} required onChange={(e) => {
                                setdDateStart(e);
                            }} maxDate={dDateEnd} />
                        </Grid>}
                        {nStatusID == 109 && <Grid item md={3} xs={12}>
                            <DatePickerFromItem name={"dContractEnd"} label={"วันที่สิ้นสุดสัญญา"} openTo="day" fullWidth required onChange={(e) => {
                                setdDateEnd(e);
                            }} minDate={dDateStart}  disabled={!objMasterData.isEditData}/>
                        </Grid>}
                        {nStatusID == 109 && <Grid item md={6} xs={12}>
                            <TextBoxForm name={"sPlaceOfWork"} label={"สถานที่ทำงาน"} required maxLength={250} disabled={!objMasterData.isEditData} />
                        </Grid>}
                        {nStatusID == 109 && <Grid item md={6} xs={12}>
                            <TextBoxForm name={"sDepartment"} label={"แผนก"} required maxLength={250} disabled={!objMasterData.isEditData} />
                        </Grid>}
                        {nStatusID == 109 && <Grid item md={6} xs={12}>
                            <TextBoxForm name={"sPosition"} label={"ตำแหน่ง"} required maxLength={250} disabled={!objMasterData.isEditData}/>
                        </Grid>}
                        <Grid item md={12} xs={12}>
                            <TextBoxForm name={"sDescription"} label={"รายละเอียดเพิ่มเติม"} multiline rows={2}
                                required={nStatusID == 110 || nStatusID == 111 || nStatusID == 112} maxLength={500}  disabled={!objMasterData.isEditData}/>
                        </Grid>
                        <Grid item md={12} xs={12} marginTop={1} marginBottom={1} >
                            <Divider></Divider>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <p style={{ fontSize: "12px" }}>แก้ไขโดย : {objMasterData?.objConsideration?.sUpdateby || "-"}</p>
                            <p style={{ fontSize: "12px" }}>วันที่แก้ไข : {objMasterData?.objConsideration?.sUpdateDate || "-"}</p>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Grid marginTop={4} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                                {objMasterData.isEditData&&<BtnSaveIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onSave(); })} />}
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Accordion>
        </Grid>
    )
};
export default Consider_From;